import React from 'react';

/*
  data should be a string contain a few sentences on what the strategoy is.
*/

const APCommentary = ({ data }) => {
  let ret = null;
  if (data && data.length > 0) {
    ret = (
      <div>
        <h3>Why We Like This Fund</h3>
        <p className="tableitem">{data}</p>
      </div>
    );
  };

  return ret;

};

export default APCommentary;